import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Package, Eye, ArrowUpRight } from 'lucide-react';

const RecentVendors = ({ vendors = [] }) => {
  const navigate = useNavigate();

  // Helper function to format date
  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    return new Date(dateString).toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric'
    });
  };

  const getVendorName = (vendor) => {
    return vendor.vendorProfile?.business_name || 
           (vendor.first_name && vendor.last_name ? `${vendor.first_name} ${vendor.last_name}` : null) ||
           vendor.name || 
           vendor.email?.split('@')[0] || 
           'Unknown Vendor';
  };

  const getVendorDate = (vendor) => {
    return vendor.created_at || vendor.vendorProfile?.created_at;
  };

  return (
    <div className="bg-white rounded-lg border border-gray-200 p-4 sm:p-6">
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-lg font-semibold text-gray-900">Recent Vendors</h2>
        <button
          onClick={() => navigate('/admin/vendors')}
          className="text-sm text-primary-600 hover:text-primary-700 font-medium flex items-center gap-1"
        >
          View All
          <ArrowUpRight className="w-4 h-4" />
        </button>
      </div>
      {vendors.length > 0 ? (
        <div className="space-y-3">
          {vendors.slice(0, 5).map((vendor) => (
            <div
              key={vendor.id}
              onClick={() => navigate(`/admin/vendors/${vendor.id}`)}
              className="flex items-center justify-between p-3 border border-gray-200 rounded-lg hover:bg-gray-50 cursor-pointer transition-colors"
            >
              <div className="flex items-center gap-3 flex-1 min-w-0">
                <div className="w-10 h-10 bg-gray-100 rounded-full flex items-center justify-center flex-shrink-0">
                  <Package className="w-5 h-5 text-gray-600" />
                </div>
                <div className="min-w-0 flex-1">
                  <p className="font-medium text-gray-900 truncate">
                    {getVendorName(vendor)}
                  </p>
                  <p className="text-xs text-gray-500">
                    {formatDate(getVendorDate(vendor))}
                  </p>
                </div>
              </div>
              <Eye className="w-5 h-5 text-gray-400 flex-shrink-0" />
            </div>
          ))}
        </div>
      ) : (
        <div className="text-center py-8">
          <Package className="w-12 h-12 text-gray-400 mx-auto mb-4" />
          <p className="text-gray-600">No recent vendors</p>
        </div>
      )}
    </div>
  );
};

export default RecentVendors;

